/**
 * Create a sandbox to get clean native functions
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var DateEnv = require('../env/date');
var di = require('../di');
var DocumentEnv = require('../env/document');
var enums = require('../constants/enums');
var Flux = require('../flux');
var Logger = require('./logger');
var SandboxStore = di.get('stores/sandbox');
var WindowEnv = require('../env/window');

/**
 * Determines if it should sandbox
 * @return {boolean}
 * @private
 */
exports.shouldSandbox = function(): boolean {
  return __SANDBOX__;
};

/**
 * Get a sandboxed collection of functions from iframe
 * Or return the window functions
 * @param {string} name
 * @return {Object}
 */
exports.get = function(name:string): any {
  if (!name) {
    throw new Error('Name is required');
  }
  if (exports.shouldSandbox()) {
    if (!SandboxStore.isInitialized()) {
      initialize();
    }
    var sandboxedFn = SandboxStore.get(name);
    if (sandboxedFn) {
      return sandboxedFn;
    }
  }
  // Fall back to window
  return WindowEnv.getGlobal(name);
};

/**
 * Create an iframe if it does not exist
 * @private
 */
var initialize = function() {
  try {
    var name = 'optimizely_' + DateEnv.now();
    //Create an iframe
    var iframeSandbox = DocumentEnv.createElement('iframe');
    iframeSandbox.name = name;
    iframeSandbox.style.display = 'none';
    //Append to document
    DocumentEnv.appendToHead(iframeSandbox);
    var iwin = iframeSandbox.contentWindow;
    var idoc = iframeSandbox.contentDocument;
    //include script element so as to import javascript functions
    idoc.write('<scr');
    idoc.write('ipt></scr');
    idoc.write('ipt>');
    idoc.close();
    //Copy sandboxed function definitions from the iframe's window object
    var sandboxedFunctionsObj = _.mapValues(enums.SandboxedFunctions, function(val) {
      return iwin[val];
    });
    Flux.dispatch(actionTypes.SANDBOXED_FUNCTIONS_ADDED, {
      sandboxedFunctions: sandboxedFunctionsObj,
    });
    // Remove iframe from document
    // Oscar:  it seems that removing the iframe remove the referenced functions
    // iframeSandbox.parentNode.removeChild(iframeSandbox);
  } catch(e) {
    Logger.warn('Unable to create a sandbox: ', e);
  }
};
